import { get } from "../httpmethods";
import { URL_API } from "../config";

export const ChartsAPI = {
    getTotalBilled: async (startDate, endDate) => {
        return await get(`${URL_API}/charts/total-billed`, {
            startDate: startDate,
            endDate: endDate
        });
    },

    getTopServices: async (startDate, endDate) => {
        return await get(`${URL_API}/charts/top-services`, {
            startDate: startDate,
            endDate: endDate
        });
    },

    getTopPets: async (startDate, endDate) => {
        return await get(`${URL_API}/charts/top-pets`, {
            startDate: startDate,
            endDate: endDate
        });
    },

    getDuration: async (startDate, endDate) => {
        return await get(`${URL_API}/charts/service-duration`, {
            startDate: startDate,
            endDate: endDate
        });
    }
}